import React from 'react';

import VistaArchivo from '../../Compartidas/VistaArchivo';

import reinscripcionesDataHelper from '../../../Helpers/ReinscripcionesData';
import { LICENCIATURAS_REINSCRIPCION } from '../../../Helpers/solicitudes';

const extraFila = solicitud => [solicitud.cuatrimestre && solicitud.cuatrimestre + ' cuatrimestre', solicitud.grupo && 'grupo ' + solicitud.grupo].filter(Boolean).join(', ');

const ArchivosReinscripcion = () => (
    <VistaArchivo
        helper={reinscripcionesDataHelper}
        encabezado='Archivo de reinscripciones'
        licenciaturas={LICENCIATURAS_REINSCRIPCION}
        rutaDetalle='/solicitud-reinscripcion-archivado/'
        extraFila={extraFila}
    />
);

export default ArchivosReinscripcion;
